module.exports = __webpack_public_path__ + "static/img/bg.f5fa0e89.png";